import { render, staticRenderFns } from "./BlacklistHistory.vue?vue&type=template&id=6a6e7f2e"
import script from "./BlacklistHistory.vue?vue&type=script&lang=js"
export * from "./BlacklistHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports